import React from 'react';
import {Display} from '../components/Display';
import { SansabotsModal } from '../components/SansabotsModal';

export const Home = () => {
    return (
        <>
            <Display/>
        </>
    )
}
